module.exports = __webpack_public_path__ + "img/other_bank.43751956.png";